import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { WebsiteService } from 'src/app/_services/website.service';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
declare function ire(string,{}): any;
function _window() : any {
  // return the global native browser window object
  return window;
}

@Component({
  selector: 'app-parapharsing-tool',
  templateUrl: './parapharsing-tool.component.html',
  styleUrls: ['./parapharsing-tool.component.scss']
})
export class ParapharsingToolComponent implements OnInit {
  creditsDetails: any;
  amplitudeService: any;
  @ViewChild('inputEditor', { static: false }) set inputContent(content: ElementRef) {
    if(content) {
      this._inputEditor = content;
    }
  }

  @ViewChild('outputEditor', { static: false }) set outputContent(content: ElementRef) {
    if(content) {
      this._outputEditor = content;
    }
  }

  @ViewChild('popover', { static: false }) private _popover!: ElementRef;
  @ViewChild('alternativesPopover', { static: false }) private _alternativesPopover!: ElementRef;
  @ViewChild('popoverOverlay', { static: false }) private _popoverOverlay!: ElementRef;

  private _inputEditor!: any;
  private _outputEditor!: any;
  private _snackBarDuration: number = 3000;
  private _delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  private _paraphraseResponse: any;
  private _wrapper: HTMLElement = document.createElement('div');
  private _paragraphToSentence: Map<string, any> = new Map();
  private _sentenceToAlternatives: Map<string, any> = new Map();
  currentSelectedSentenceState: any = {
    index: -1,
    alternatives: {},
    sentenceTag: null
  };
  wordCounts: any = {
    input: 0,
    output: 0
  };
  paraphraseTemperature: number = 1.5;
  toggleDiffOptionModel: boolean = true;
  isLimitExhausted: boolean = false;
  aboveLimitText: string = '';
  loader: boolean = false;
  paraphraserLimit: number = 500;


  constructor(
    private _appService: WebsiteService,
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.titleService.setTitle('무료 의역 도구 | AI로 온라인에서 문장 고치기 | Trinka  ');
    this.metaTagService.updateTag({ name: 'description', content: "Trinka의 강력한 무료 의역 도구를 사용하면 원래의 뜻을 유지하면서도 고품질의 일관성 있는 온라인 의역이 가능합니다." });
    this.metaTagService.updateTag({ property: 'og:title', content: '무료 의역 도구 | AI로 온라인에서 문장 고치기 | Trinka  ' });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka의 강력한 무료 의역 도구를 사용하면 원래의 뜻을 유지하면서도 고품질의 일관성 있는 온라인 의역이 가능합니다." });
    this.metaTagService.updateTag({ name: 'keywords', content: 'paraphrasing tool, sentence rephraser, paraphraser, online paraphraser, rephrase online, paraphrasing meaning, rewrite article, rephrase sentence online, online paraphrasing tool, paraphrasing tool free, rewriter tool, rephrase tool, sentence changer, paraphrasing tool online free' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/paraphrasing-tool' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/online_paraphrase_banner.svg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '무료 의역 도구 | AI로 온라인에서 문장 고치기 | Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka의 강력한 무료 의역 도구를 사용하면 원래의 뜻을 유지하면서도 고품질의 일관성 있는 온라인 의역이 가능합니다." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/online_paraphrase_banner.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/paraphrasing-tool' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/paraphrasing-tool' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/paraphrasing-tool' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/paraphrasing-tool' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/paraphrasing-tool' });
    
    this._intialSetup();
    
  }

  private async _intialSetup() {
    await this._delay(0);
    this._wrapper.classList.add('wrapper');
    this._attachEventListeners();
  }

  private _uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private _alternativeSelectionCleanup(keepHoverState: boolean = false) {
    if(!keepHoverState) {
      this._clearSelectionState();
    }
    this.currentSelectedSentenceState.alternatives = {};
    this.currentSelectedSentenceState.sentenceTag = null;
    this.currentSelectedSentenceState.index = -1;
    this._popover.nativeElement.style.display = 'none';
    this._alternativesPopover.nativeElement.style.display = 'none';
  }

  private _debounce(callback: Function, interval: number) {
    let debounceTimeoutId: any;

    return (...args: any[]) => {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
  }

  private _throttle(callback: Function, interval: number) {
    let enableCall = true;

    return (...args: any[]) => {
      if (!enableCall) return;

      enableCall = false;
      callback.apply(this, args);
      setTimeout(() => enableCall = true, interval);
    }
  }

  private _attachEventListeners() {
    this._attachPasteEventListener(this._inputEditor.nativeElement);
    this._attachKeydownEventListener(this._inputEditor.nativeElement);
  }

  private _attachKeydownEventListener(element: HTMLElement) {
    element.onkeydown = (e: any) => {
      if(!element.children.length) {
        let newParagraph = document.createElement("p");
        newParagraph.innerHTML = "<br />";
        element.appendChild(newParagraph);
        _window().getSelection().collapse(newParagraph, 0);
        e.preventDefault();
      }
    }

    const observer = new MutationObserver((mutationList, observer) => {
      for(let ilength = mutationList.length, i = 0; i < ilength; ++i) {
        const addedNodes = mutationList[i].addedNodes;
        for(let jlength = addedNodes.length, j = 0; j < jlength; ++j) {
          const node: any = addedNodes[j];
          // console.log(node, node.id);
          // if(!node.id) {
          //   let randomNumber = this._uuidv4();
          //   node.id = `${randomNumber}`;
          // }
        }
      }
    });

    observer.observe(element, { childList: true });
  }

  private _attachPasteEventListener(element: HTMLElement) {
    element.addEventListener('paste', ($event: any) => {
      $event.preventDefault()
      let text = $event.clipboardData.getData('text/plain');
      text = text.replace(/\n{2,}/g, '\n');
      document.execCommand('insertText', false, text);
    });
  }

  private _getMultilineSpanBoundingRect(element: HTMLElement) {
    if(!element.textContent) return;

    // TODO: adjustment is the wrapper padding need re-organize markup structure
    const adjustment = 24;
    const lines = element.textContent.split('\n');
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight);

    let top = Number.MAX_VALUE;
    let bottom = Number.MIN_VALUE;

    for (let i = 0; i < lines.length; i++) {
      const lineTop = element.offsetTop + (i * lineHeight);
      const lineBottom = lineTop + lineHeight;

      if (lineTop < top) {
        top = lineTop;
      }

      if (lineBottom > bottom) {
        bottom = lineBottom;
      }
    }

    let left = element.offsetLeft;
    let right = element.offsetWidth;

    top -= adjustment;
    left -= adjustment;
    right -= adjustment;
    bottom -= adjustment;

    return { top, right, bottom, left };
  }

  private _getRelativePosition(element: HTMLElement) {
    const referenceRect = element.getBoundingClientRect();
    const parentRect = this._popoverOverlay.nativeElement.getBoundingClientRect();
    const popoverRect = this._popover.nativeElement.getBoundingClientRect();

    const relativePos: any = {
      top: (referenceRect.top - parentRect.top) - popoverRect.height,
      right: parentRect.right - referenceRect.right,
      bottom: parentRect.bottom - referenceRect.bottom,
      left: (referenceRect.left - parentRect.left)
    };

    return relativePos;
  }

  private _hoverEventListeners(editor: HTMLElement, eventOriginFromEditor: string) {
    const elements: NodeListOf<HTMLElement> = editor.querySelectorAll('sentence[static="false"]');
    elements.forEach((sentence: HTMLElement) => {
      sentence.addEventListener('mouseover', this._debounce(($event: any) => {
        let target = ($event.target as HTMLElement);

        target.setAttribute('hovered', 'true');

        // find twin node to highlight on selection
        let twin;
        if (eventOriginFromEditor === 'output') {
          twin = this._inputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        } else {
          twin = this._outputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        }

        if (!twin) return;
        twin.setAttribute('hovered', 'true');
      }, 300));

      sentence.addEventListener('mouseout', this._debounce(($event: any) => {
        let target = ($event.target as HTMLElement);

        target.setAttribute('hovered', 'false');

        // find twin node to highlight on selection
        let twin;
        if (eventOriginFromEditor === 'output') {
          twin = this._inputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        } else {
          twin = this._outputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        }

        if (!twin) return;
        twin.setAttribute('hovered', 'false');
      }, 300));
    });
  }

  private _clickEventListeners(editor: HTMLElement, eventOriginFromEditor: string) {
    const elements: NodeListOf<HTMLElement> = editor.querySelectorAll('sentence[static="false"]');
    elements.forEach((sentence: HTMLElement) => {
      sentence.addEventListener('click', this._throttle(($event: any) => {
        let target = ($event.target as HTMLElement);
        this._clearSelectionState();

        target.setAttribute('selected', 'true');
        this.currentSelectedSentenceState.sentenceTag = target;

        // find twin node to highlight on selection
        let twin;
        if(eventOriginFromEditor === 'output') {
          twin = this._inputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        } else {
          twin = this._outputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
          this.currentSelectedSentenceState.sentenceTag = twin;
        }

        if(!twin) return;
        twin.setAttribute('selected', 'true');
        // twin.scrollIntoView({behavior: 'smooth'});

        const multiLineRect: any = this._getMultilineSpanBoundingRect(this.currentSelectedSentenceState.sentenceTag);
        const parentRect = this._popoverOverlay.nativeElement.getBoundingClientRect();
        const popoverRect = this._popover.nativeElement.getBoundingClientRect();
        const currentSelectedElement = this.currentSelectedSentenceState.sentenceTag.getBoundingClientRect();
        const top = currentSelectedElement.top - parentRect.top;
        const bottom = parentRect.bottom - currentSelectedElement.bottom;
        const left = currentSelectedElement.left - parentRect.left;
        const right = parentRect.right - currentSelectedElement.right;

        this.currentSelectedSentenceState.alternatives = this._getParaphraserAlternatives(this.currentSelectedSentenceState.sentenceTag.id);
        this.currentSelectedSentenceState.index = Number(this.currentSelectedSentenceState.sentenceTag.getAttribute('paraphrased-index'));
        this._popover.nativeElement.style.display = 'block';
        this._popover.nativeElement.style.top = `${multiLineRect.top - (popoverRect.height + 10)}px`;
        this._popover.nativeElement.style.left = `${multiLineRect.left}px`;

        if(this.currentSelectedSentenceState.alternatives.output_sentence.length && this.currentSelectedSentenceState.alternatives.output_sentence.length > 1) {
          this._alternativesPopover.nativeElement.style.display = 'block';
          this._alternativesPopover.nativeElement.style.top = `${top + currentSelectedElement.height + 25}px`;
          this._alternativesPopover.nativeElement.style.left = `${left}px`;
        }

      }, 300));
    });
  }

  private _getParaphraserAlternatives(id: string) {
    return this._paraphraseResponse.map((paragraph) => paragraph.result)
    .flat()
    .find((sentence) => sentence.file_id === id);
  }

  private _clearSelectionState() {
    let inputEditorAllActiveSentence = this._inputEditor.nativeElement.querySelectorAll('sentence[selected="true"]');
    let outputEditorAllActiveSentence = this._outputEditor.nativeElement.querySelectorAll('sentence[selected="true"]');

    inputEditorAllActiveSentence.forEach((sentence: any) => {
      sentence.setAttribute('selected', 'false');
    });
    outputEditorAllActiveSentence.forEach((sentence: any) => {
      sentence.setAttribute('selected', 'false');
    });
  }

  private _paraphraseFeedback(requestBody: any) {
    this._appService.paraphraseFeedbackRequest(requestBody)
    .subscribe({
      complete: () => { },
      next: (response: any) => {
        this._snackBar.open('Thank you for your feedback!', '', {
          duration: this._snackBarDuration
        });
      },
      error: (error) => {
        this._snackBar.open('Something went wrong, please try again later', '', {
          duration: this._snackBarDuration
        });
      }
    });
  }

  private _makeParaphraseRequest(list: any) {
    this.loader = true;
    this._appService.sendToParaphraseRequest(list)
    .subscribe({
      complete: () => { },
      next: (response: any) => {
        if(!response.length) return;

        this._paraphraseResponse = response;
        this._paragraphToSentence = new Map();
        this._sentenceToAlternatives = new Map();

        response.forEach(paraphrase => {
          this._paragraphToSentence.set(paraphrase.id, paraphrase.result)
          paraphrase.result.forEach(sentence => {
            this._sentenceToAlternatives.set(sentence.file_id, sentence.output_sentence);
          });
        });

        this._updateEditors();
        this.loader = false;
      },
      error: (error) => {
        this.loader = false;
      }
    });
  }

  private _updateEditors() {
    let inputHTML = this._wrapper.cloneNode(true) as HTMLElement;
    let outputHTML = this._wrapper.cloneNode(true) as HTMLElement;

    for (let paragraph of this._paragraphToSentence.keys()) {

      let listOfSentences = this._paragraphToSentence.get(paragraph);
      let inputParagraphNode = inputHTML.querySelector(`[id="${paragraph}"]`);
      let outputParagraphNode = outputHTML.querySelector(`[id="${paragraph}"]`);

      listOfSentences.forEach((sentence: any) => {
        let uniqueId = sentence.file_id;
        let spaceNode = document.createTextNode(" ");
        const newSentence = document.createElement('sentence');
        newSentence.id = uniqueId;
        newSentence.setAttribute('selected', 'false');
        newSentence.innerText = `${sentence.original_sentence}`;
        newSentence.setAttribute('static', 'false');
        inputParagraphNode?.appendChild(newSentence);
        // add space after each sentence
        inputParagraphNode?.appendChild(spaceNode);

        let outputSentence: HTMLElement = newSentence.cloneNode(true) as HTMLElement;
        if(this.toggleDiffOptionModel) {
          outputSentence.innerHTML = `${sentence.output_sentence[0].suggestion_diff}`;
        } else {
          outputSentence.innerText = `${sentence.output_sentence[0].suggestion}`;
        }
        outputSentence.setAttribute('paraphrased-index', '0');
        outputParagraphNode?.appendChild(outputSentence);
        // add space after each sentence
        outputParagraphNode?.appendChild(spaceNode.cloneNode(true));
      });
    }

    this._inputEditor.nativeElement.innerHTML = inputHTML.innerHTML;
    this._outputEditor.nativeElement.innerHTML = outputHTML.innerHTML;

    if(this.aboveLimitText.length) {
      let lastParagraph = this._inputEditor.nativeElement.querySelector('p[class="text-cropped"]');
      let limitExhaustSpan = document.createElement('span');
      limitExhaustSpan.classList.add('limit-exhausted');
      limitExhaustSpan.innerText = this.aboveLimitText;
      lastParagraph.appendChild(limitExhaustSpan);
      this.isLimitExhausted = true;
    }

    this._clickEventListeners(this._inputEditor.nativeElement, 'input');
    this._clickEventListeners(this._outputEditor.nativeElement, 'output');
    this._hoverEventListeners(this._inputEditor.nativeElement, 'input');
    this._hoverEventListeners(this._outputEditor.nativeElement, 'output');
    this._updateCounts();
  }

  private _wordCount(text) {
    return text.split(/(\s+)/).filter((x) => x.trim().length > 0).length;
  }

  private _prepRequestBody() {
    this.aboveLimitText = '';
    this.isLimitExhausted = false;
    let requestBody: any = [];
    let wordCount: number = 0;
    let content = this._inputEditor.nativeElement.innerHTML;
    const domParser = new DOMParser();
    const inputEditorDOM = domParser.parseFromString(content, 'text/html');

    let listOfParagraphs = inputEditorDOM.querySelectorAll('p');

    listOfParagraphs.forEach((paragraph: HTMLElement) => {
      paragraph.classList.remove('text-cropped');
      paragraph.classList.remove('limit-exhausted');
      let id = this._uuidv4();
      let text = paragraph.innerText;
      const newParagraph = document.createElement('p');
      newParagraph.id = id;
      this._wrapper.appendChild(newParagraph);

      if (wordCount < this.paraphraserLimit) {
        let currentText = text.trim().split(/(\s+)/).filter((x) => x.trim().length > 0);
        let currentWordCount = this._wordCount(text.trim());
        if ((wordCount + currentWordCount) > this.paraphraserLimit) {
          let diff = (wordCount + currentWordCount) - (this.paraphraserLimit);
          text = currentText.splice(0, (currentWordCount - diff)).join(' ');
          newParagraph.classList.add('text-cropped');
          this.aboveLimitText = currentText.join(' ');
        }

        // if (wordCount < this.paraphraserLimit) { }
        if(text.trim()) {
          newParagraph.setAttribute('static', 'false');
          let prepParagphForRequest: any = {
            "paragraph": text,
            "id": id,
            "language": "US",
            "temperature": this.paraphraseTemperature
          };
          requestBody.push(prepParagphForRequest);
        } else {
          newParagraph.setAttribute('static', 'true');
        }

        wordCount += currentWordCount;
      } else {
        wordCount += this._wordCount(text.trim());
        this.isLimitExhausted = true;
        newParagraph.setAttribute('static', 'true');
        newParagraph.classList.add('limit-exhausted');
        newParagraph.innerText = text;
      }
    });

    return { requestBody, wordCount };
  }

  private _updateOutputEditorForToggleDiffSuggestions() {
    for (let paragraph of this._paragraphToSentence.keys()) {
      let listOfSentences = this._paragraphToSentence.get(paragraph);
      listOfSentences.forEach((sentence: any) => {
        let uniqueId = sentence.file_id;

        let sentenceTag: HTMLElement = this._outputEditor.nativeElement.querySelector(`[id="${uniqueId}"]`);
        let currentSelectionIndex = sentenceTag.getAttribute('paraphrased-index');

        if(this.toggleDiffOptionModel) {
          sentenceTag.innerHTML = `${sentence.output_sentence[currentSelectionIndex].suggestion_diff}`;
        } else {
          sentenceTag.innerText = `${sentence.output_sentence[currentSelectionIndex].suggestion}`;
        }
      });
    }
  }

  private async _copyTextToClipboard(text: string) {
    if(!text.length) return;
    try {
      await navigator.clipboard.writeText(text);
      this._snackBar.open('의역된 텍스트 복사됨', '', {
        duration: this._snackBarDuration
      });
    } catch (e) {
      console.log(e);
      this._snackBar.open('Copy option is not available on Insecure site', '', {
        duration: this._snackBarDuration
      });
    }
  }

  private _pasteHtmlAtCaret(html: any, selectPastedContent: any) {
    var sel, range;
    if (window.getSelection) {
      // IE9 and non-IE
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();

        // Range.createContextualFragment() would be useful here but is
        // only relatively recently standardized and is not supported in
        // some browsers (IE9, for one)
        var el = document.createElement("div");
        el.innerHTML = html;
        var frag = document.createDocumentFragment(), node, lastNode;
        while ( (node = el.firstChild) ) {
          lastNode = frag.appendChild(node);
        }
        var firstNode = frag.firstChild;
        range.insertNode(frag);

        // Preserve the selection
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          if (selectPastedContent) {
            range.setStartBefore(firstNode);
          } else {
            range.collapse(true);
          }
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    }
  }

  private _checkForLimit() {
    if(this.wordCounts.input <= this.paraphraserLimit) return;
  }

  private _updateCounts() {
    let listOfParagraphs = this._inputEditor.nativeElement.querySelectorAll('p');
    let inputWordCount = 0;
    listOfParagraphs.forEach((paragraph: HTMLElement) => {
      let text = paragraph.innerText;
      inputWordCount += this._wordCount(text.trim());
    });
    this.wordCounts.input = inputWordCount;
    this.wordCounts.output = this._wordCount(this._outputEditor.nativeElement.innerText.trim());

    if(this._inputEditor.nativeElement.innerText === '') this.wordCounts.input = 0;
    if(this._outputEditor.nativeElement.innerText === '') this.wordCounts.output = 0;
  }

  paraphrase() {
    this._alternativeSelectionCleanup(false);
    this._wrapper.innerHTML = '';
    let { requestBody, wordCount } = this._prepRequestBody();
    if(requestBody.length) {
      this._makeParaphraseRequest(requestBody);
    }
  }

  async popoverOptionSelected($event: any, option: string, originalSentence: string = '', paraphrasedSentence: string = '') {
    $event.stopPropagation();

    let requestBody = {};
    switch (option) {
      case 'like':
      case 'dislike':
        requestBody = {
          originalSentence,
          paraphrasedSentence,
          feedback: option
        };
        this._paraphraseFeedback(requestBody);
      break;

      case 'copy':
        this._copyTextToClipboard(paraphrasedSentence);
      break;

      default:
      break;
    }
    // this._alternativeSelectionCleanup(true);
  }

  async copyOutputEditorContent() {
    if(this.toggleDiffOptionModel) return;

    let content = this._outputEditor.nativeElement.innerText;
    this._copyTextToClipboard(content);
  }

  clearEditors() {
    this._inputEditor.nativeElement.innerHTML = '';
    this._outputEditor.nativeElement.innerHTML = '';
    this.paraphraseTemperature = 1.5;
    this.toggleDiffOptionModel = false;

    this._alternativeSelectionCleanup(false);
    this._updateCounts();
  }

  switchToTheAlternative(alternative: any, index: any) {
    if(this.toggleDiffOptionModel) {
      this.currentSelectedSentenceState.sentenceTag.innerHTML = alternative.suggestion_diff;
    } else {
      this.currentSelectedSentenceState.sentenceTag.innerText = alternative.suggestion;
    }
    this.currentSelectedSentenceState.sentenceTag.setAttribute('paraphrased-index', index);
    this._alternativeSelectionCleanup(false);
  }

  onToggleDiffOption() {
    this._alternativeSelectionCleanup(false);
    this._updateOutputEditorForToggleDiffSuggestions();
  }

  closePopover() {
    this._alternativeSelectionCleanup(true);
  }

  onInputEditorChange($event: any) {
    let editor = $event.target;

    this._updateCounts();
    this._checkForLimit();
  }

  setCaret(el: any) {
    let range = document.createRange()
    let sel = window.getSelection()

    range.setStart(el.querySelector('[id="limit-exhausted"]'), 0)
    range.collapse(true)

    sel.removeAllRanges()
    sel.addRange(range)
  }

  placeCaretAfterNode(node) {
    if (typeof window.getSelection != "undefined") {
      var range = document.createRange();
      range.setStartAfter(node);
      range.collapse(true);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  updateParaphraseTemperature(event) {
    this.paraphrase();
  }

  openFeedbackModal(): void {
    const dialogRef = this._dialog.open(FeedbackModalComponent, {
      width: '464px',
      height: 'auto',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
